import CodeForm from './CodeForm';

export default CodeForm;
